@if (studentSchedule(); as studentSchedule) {
  <div class="flex align-items-center gap-spacing-xs">
    <app-user-avatar
      size="lg"
      [showActiveIndicator]="false"
      [label]="avatarUrl() ? '' : studentSchedule.student.name.charAt(0).toUpperCase()"
      [imgSrc]="'data:image/jpeg;base64,' + avatarUrl()">
    </app-user-avatar>
    <div class="flex flex-column">
      <span class="body-large-bold text-primary-color">{{ studentSchedule.student.name }}</span>
      <span class="body-small-regular text-caption-color">{{ studentSchedule.student.grade }}</span>
    </div>
  </div>

  @for (day of studentSchedule.schedule; track $index) {
    <div class="day-schedule table-bg-hover-bg radius-lg p-spacing-xl border-1 border-neutral-base-primary-border mt-spacing-3xl">
      <div class="day-summary-header flex justify-content-between align-items-center">
        <div class="flex align-items-center gap-spacing-xs">
          <span class="body-large-bold text-secondary-color">{{ day.dayName }}</span>
          <span class="body-large-regular text-caption-color">{{ day.dateString ?? (day.date | date: "MM/dd/yyyy") }}</span>
        </div>
      </div>

      <div class="rides-summary radius-lg text-inverse-bg border-1 border-neutral-base-primary-border mt-spacing-xl">
        @if (day.rides.length == 0) {
          <div class="no-rides py-spacing-5xl flex justify-content-center">
            <span class="body-medium-regular text-caption-color">No rides for this day.</span>
          </div>
        } @else {
          @for (ride of day.rides; track $index) {
            <div class="row-item flex">
              <div
                class="column-item p-spacing-md align-content-center"
                style="width: 100px">
                <span>{{ ride.period }}</span>
              </div>
              <div class="column-item p-spacing-md align-content-center flex-1">
                <div class="flex flex-column gap-spacing-xs">
                  <span>{{ ride.startTime | timeFormat }}</span>
                  <span>{{ ride.endTime | timeFormat }}</span>
                </div>
              </div>
              <div class="column-item p-spacing-md align-content-center flex-1">
                <span>{{ ride.type }}</span>
              </div>
              <div class="column-item p-spacing-md align-content-center flex-1">
                <app-tag
                  class="ride-status-tag-sm"
                  styleClass="bold"
                  [content]="ride.status"
                  sizeClass="tag-sm"
                  [severityClass]="ride.statusSeverity">
                </app-tag>
              </div>
            </div>
          }
        }
      </div>
    </div>
  }
}
